module.exports = __webpack_public_path__ + "assets/img/onekonggou_1.fe70a619.jpg";